import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-tag',
  templateUrl: './lex-xi-tag.component.html',
  styleUrls: ['./lex-xi-tag.component.scss'],
  standalone: false,
})
export class LexXiTagComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() text: string;
  @Input() icon: string;
  @Input() type: 'auto-generated' | 'user' | 'user-etc' | 'document';
  @Input() canUserDelete = false;
  @Input() tooltip: string;
  @Output() onClick = new EventEmitter<Event>();

  color: string;
  tone: string;

  constructor() {}

  ngOnInit(): void {
    switch (this.type) {
      case 'auto-generated':
        this.color = 'CX';
        break;
      case 'user':
      case 'user-etc':
        this.icon = this.canUserDelete ? 'cancel' : '';
        this.tone = 'light';
        break;
      case 'document':
        this.icon = this.canUserDelete ? 'cancel' : '';
        break;
    }
  }

  onIconClicked($event) {
    this.onClick.emit($event);
  }
}
